import {Component, OnInit, Input, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-modal-animation',
  templateUrl: './modal-animation.component.html',
  styleUrls: ['./modal-animation.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ModalAnimationComponent implements OnInit {

  @Input() modalClass: string;
  @Input() contentClass: string;
  @Input() modalID: string;
  @Input() backDrop = false;

  constructor() { 
    	console.log('this.modalID',this.modalID)

  }

  ngOnInit() {
    console.log('this.modalID',this.modalID)

  }

  close(event) {
    console.log('1', document.querySelector('#' + event));
    document.querySelector('#' + event).classList.remove('md-show');
      console.log('2', document.querySelector('#' + event).classList);

  }
}
